import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip, Dropdown, Menu } from 'antd';
import { ThreeDotsIcon } from '../../../custom_shared/icons';
import { ClickableIcon } from '../../../common/components';
import { ReRunAnalysisMenuItem, ExportToJsonMenuItem } from '../../../custom_shared/components';
import { useAppStore } from '../../stores';

const MoreActionsMenu: React.FC = () => {
    const appStore = useAppStore();

    const { actionStore, sessionStore, controlStateStore, worksheetsSubmissionStore } = appStore;

    const [menuVisible, setMenuVisible] = React.useState(false);

    const moreActionsMenu = (
        <Menu onClick={() => setMenuVisible(false)}>
            <ReRunAnalysisMenuItem
                appStore={appStore}
                sessionStore={sessionStore}
                disabled={worksheetsSubmissionStore.isAnyWorksheetProcessing}
            />
            <ExportToJsonMenuItem onClick={() => actionStore.downloadJson()} />
        </Menu>
    );

    return (
        <Dropdown
            placement="bottomRight"
            visible={menuVisible}
            overlay={moreActionsMenu}
            onVisibleChange={setMenuVisible}
            trigger={['click']}
            arrow
        >
            <Tooltip title="More actions">
                <ClickableIcon
                    icon={ThreeDotsIcon}
                    onClick={() => setMenuVisible(true)}
                    disabled={controlStateStore.actionsDisabled}
                />
            </Tooltip>
        </Dropdown>
    );
};

export default observer(MoreActionsMenu);
